export const PAGE_NAVIGATION_DATA_REQUEST = 'PAGE_NAVIGATION_DATA_REQUEST';
export const PAGE_NAVIGATION_DATA_SUCCESS = 'PAGE_NAVIGATION_DATA_SUCCESS';
export const PAGE_NAVIGATION_DATA_FAIL = 'PAGE_NAVIGATION_DATA_FAIL';
